// extracted by mini-css-extract-plugin
module.exports = {"expandableNotes":"styles-module__expandableNotes___bKrcz"};